import * as gaEvents from '../events';
import type { IInitialEvent } from '../types';

import { sendEventToGA } from './sendEventToGA';

const createGASender =
  <TArgs extends unknown[]>(eventFactory: (...args: TArgs) => IInitialEvent) =>
  (...args: TArgs) =>
    sendEventToGA(eventFactory(...args));

/* rates page */
export const sendEventPaidClick = createGASender(gaEvents.eventPaidClick);
export const sendEventOfferSent = createGASender(gaEvents.eventSendOffer);
export const sendEventRatesChartInit = createGASender(gaEvents.eventRatesChartInit);
export const sendEventRatesChartChange = createGASender(gaEvents.eventRatesChartChange);
export const sendEventRatesChartViewItem = createGASender(gaEvents.eventRatesChartViewItem);
export const sendEventRatesChartSelectItem = createGASender(gaEvents.eventRatesChartSelectItem);

/* credit form */
export const sendEventFillFormField = createGASender(gaEvents.eventFillFormField);
export const sendEventFormFieldError = createGASender(gaEvents.eventFormFieldError);
export const sendEventInvalidForm = createGASender(gaEvents.eventInvalidForm);
export const sendEventChangeFormFieldDefaultParam = createGASender(gaEvents.eventChangeFormFieldDefaultParam);
export const sendEventGetCodeBySms = createGASender(gaEvents.eventGetCodeBySms);
export const sendEventInvalidSmsCode = createGASender(gaEvents.eventInvalidSmsCode);
export const sendEventChangePhoneNumber = createGASender(gaEvents.eventChangePhoneNumber);
export const sendEventRequestNewCode = createGASender(gaEvents.eventRequestNewCode);
export const sendEventAuthorizationError = createGASender(gaEvents.eventAuthorizationError);
export const sendEventAuthorizationSuccess = createGASender(gaEvents.eventAuthorizationSuccess);
export const sendEventStepContacts = createGASender(gaEvents.eventStepContacts);
export const sendEventStepCreditPurpose = createGASender(gaEvents.eventStepCreditPurpose);
export const sendEventStepPassport = createGASender(gaEvents.eventStepPassport);
export const sendEventAdditionalData = createGASender(gaEvents.eventStepAdditionalData);
export const sendEventStepWorkplace = createGASender(gaEvents.eventStepWorkplace);
export const sendEventShowStep = createGASender(gaEvents.eventShowStep);

/* offers */
export const sendEventShowOffers = createGASender(gaEvents.eventShowOffers);
export const sendEventEmptyOffers = createGASender(gaEvents.eventEmptyOffers);
export const sendEventChangeLocation = createGASender(gaEvents.eventChangeLocation);
export const sendEventChangeFilter = createGASender(gaEvents.eventChangeFilter);
export const sendEventGoToOfferWebsite = createGASender(gaEvents.eventGoToOfferWebsite);

/* consents */
export const sendEventOpenConsentsScreen = createGASender(gaEvents.eventOpenConsentsScreen);
export const sendEventConsentsScreenButtonClick = createGASender(gaEvents.eventConsentsScreenButtonClick);
export const sendEventOnDisableAgreementPersonalData = createGASender(gaEvents.eventOnDisableAgreementPersonalData);
export const sendEventOnEnableAgreementAdvertising = createGASender(gaEvents.eventOnEnableAgreementAdvertising);

/* mpl */
export const sendEventOnShowMplOffersLoadingScreenStep = createGASender(gaEvents.eventOnShowMplOffersLoadingScreenStep);
export const sendEventOnRatingDescriptionClickOnMplOffersLoadingScreen = createGASender(
  gaEvents.eventOnRatingDescriptionClickOnMplOffersLoadingScreen,
);
export const sendEventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen = createGASender(
  gaEvents.eventOnShowRatingDescriptionPopupOnMplOffersLoadingScreen,
);
export const sendEventOnShowPDNOnMplOffersLoadingScreen = createGASender(
  gaEvents.eventOnShowPDNOnMplOffersLoadingScreen,
);
export const sendEventOnShowApprovedOffersPopupOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnShowApprovedOffersPopupOnMplCreditSelectionScreen,
);
export const sendEventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnCloseApprovedOffersPopupOnMplCreditSelectionScreen,
);
export const sendEventOnShowApprovedOfferOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnShowApprovedOfferOnMplCreditSelectionScreen,
);
export const sendEventOnClickApprovedOfferOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnClickApprovedOfferOnMplCreditSelectionScreen,
);
export const sendEventOnClickWhyThisAmountOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnClickWhyThisAmountOnMplCreditSelectionScreen,
);
export const sendEventOnClickChangeAmountOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnClickChangeAmountOnMplCreditSelectionScreen,
);
export const sendEventOnClickApprovalDateOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnClickApprovalDateOnMplCreditSelectionScreen,
);
export const sendEventOnShowTopXOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnShowTopXOnMplCreditSelectionScreen,
);
export const sendEventOnSubmitClickTopXOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnSubmitClickTopXOnMplCreditSelectionScreen,
);
export const sendEventOnShowRefusedOffersOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnShowRefusedOffersOnMplCreditSelectionScreen,
);
export const sendEventOnClickWhyRefusedOffersOnMplCreditSelectionScreen = createGASender(
  gaEvents.eventOnClickWhyRefusedOffersOnMplCreditSelectionScreen,
);

export const sendEventOnShowConditionsSelectionScreen = createGASender(gaEvents.eventOnShowConditionsSelectionScreen);

export const sendEventOnClickTermUnavailableReason = createGASender(gaEvents.eventOnClickTermUnavailableReason);

export const sendEventOnClickChangeOption = createGASender(gaEvents.eventOnClickChangeOption);

export const sendEventOnClickInsuranceDetails = createGASender(gaEvents.eventOnClickInsuranceDetails);

export const sendEventOnOpenDocumentsList = createGASender(gaEvents.eventOnOpenDocumentsList);

export const sendEventOnChangeAmount = createGASender(gaEvents.eventOnChangeAmount);

export const sendEventOnEditConditionsClickOnLoadingDocumentsScreen = createGASender(
  gaEvents.eventOnEditConditionsClickOnLoadingDocumentsScreen,
);

export const sendEventOnShowLoadingDocumentsScreen = createGASender(gaEvents.eventOnShowLoadingDocumentsScreen);

export const sendEventOnSelectDocumentInChoiceModal = createGASender(gaEvents.eventOnSelectDocumentInChoiceModal);

export const sendEventOnShowAgreementSigningScreen = createGASender(gaEvents.eventOnShowAgreementSigningScreen);

export const sendEventOnDocumentClickOnAgreementSigningScreen = createGASender(
  gaEvents.eventOnDocumentClickOnAgreementSigningScreen,
);

export const sendEventOnSubmitAgreementSigning = createGASender(gaEvents.eventOnSubmitAgreementSigning);

export const sendEventOnSendSmsAgreementSigning = createGASender(gaEvents.eventOnSendSmsAgreementSigning);

export const sendEventOnSmsErrorAgreementSigning = createGASender(gaEvents.eventOnSmsErrorAgreementSigning);

export const sendEventOnSendNewSmsAgreementSigning = createGASender(gaEvents.eventOnSendNewSmsAgreementSigning);

export const sendEventOnShowOfferApprovalModal = createGASender(gaEvents.eventOnShowOfferApprovalModal);

export const sendEventOnClickButtonOffersOnOfferApprovalModal = createGASender(
  gaEvents.eventOnClickButtonOffersOnOfferApprovalModal,
);

export const sendEventOnShowCoolingPeriodScreen = createGASender(gaEvents.eventOnShowCoolingPeriodScreen);

export const sendEventOnShowWhyNeedCoolingPeriodModal = createGASender(gaEvents.eventOnShowWhyNeedCoolingPeriodModal);

export const sendEventOnShowAgreementSignedScreen = createGASender(gaEvents.eventOnShowAgreementSignedScreen);

export const sendEventOnShowOfferDisbursementScreen = createGASender(gaEvents.eventOnShowOfferDisbursementScreen);

export const sendEventOnClickNotSendSmsOnOfferDisbursementScreen = createGASender(
  gaEvents.eventOnClickNotSendSmsOnOfferDisbursementScreen,
);

export const sendEventOnShowNotSendSmsModalOnOfferDisbursementScreen = createGASender(
  gaEvents.eventOnShowNotSendSmsModalOnOfferDisbursementScreen,
);

export const sendEventOnClickRedirectToBankOnOfferDisbursementScreen = createGASender(
  gaEvents.eventOnClickRedirectToBankOnOfferDisbursementScreen,
);

export const sendEventOnClickOpenDocumentOnOfferDisbursementScreen = createGASender(
  gaEvents.eventOnClickOpenDocumentOnOfferDisbursementScreen,
);

export const sendEventOnShowClientRefusedScreen = createGASender(gaEvents.eventOnShowClientRefusedScreen);

export const sendEventOnClickGoToMainOnClientRefusedScreen = createGASender(
  gaEvents.eventOnClickGoToMainOnClientRefusedScreen,
);

export const sendEventOnClickSelectOfferOnConditionsSelectionScreen = createGASender(
  gaEvents.eventOnClickSelectOfferOnConditionsSelectionScreen,
);

export const sendEventOnClickActiveOfferConflictOnConditionsSelectionScreen = createGASender(
  gaEvents.eventOnClickActiveOfferConflictOnConditionsSelectionScreen,
);

export const sendEventOnToggleInsuranceOnConditionsSelectionScreen = createGASender(
  gaEvents.eventOnToggleInsuranceOnConditionsSelectionScreen,
);

/* full deal mfo */
export const sendEventShowFullDealBlock = createGASender(gaEvents.eventShowFullDealBlock);
export const sendEventApplyForLoan = createGASender(gaEvents.eventApplyForLoan);
export const sendEventLoanConditions = createGASender(gaEvents.eventLoanConditions);
export const sendEventCancelSelection = createGASender(gaEvents.eventCancelSelection);
export const sendEventSubmitFullDealApplication = createGASender(gaEvents.eventSubmitFullDealApplication);
export const sendEventMyApplications = createGASender(gaEvents.eventMyApplications);
export const sendEventButtonClick = createGASender(gaEvents.eventButtonClick);
export const sendEventValidationError = createGASender(gaEvents.eventValidationError);
export const sendEventCloseSMSPopupClick = createGASender(gaEvents.eventCloseSMSPopupClick);

/* kredity new page */
export const sendEventShowLandingPage = createGASender(gaEvents.eventShowLandingPage);
export const sendEventOnClickChangeLocation = createGASender(gaEvents.eventOnClickChangeLocation);
export const sendEventOnContinueButton = createGASender(gaEvents.eventOnContinueButton);
export const sendEventOnClickFillManuallyButton = createGASender(gaEvents.eventOnClickFillManuallyButton);
export const sendEventOnClickGosuslugiButton = createGASender(gaEvents.eventOnClickGosuslugiButton);
export const sendEventOnClickOfferCard = createGASender(gaEvents.eventOnClickOfferCard);
export const sendEventOnSubmitOffer = createGASender(gaEvents.eventOnSubmitOffer);
export const sendEventOnChangeFilter = createGASender(gaEvents.eventOnChangeFilter);

/* biometry */
export const sendEventClickBiometry = createGASender(gaEvents.eventClickBiometry);
export const sendEventShowBiometry = createGASender(gaEvents.eventShowBiometry);
export const sendEventGoEsiaFromBiometry = createGASender(gaEvents.eventGoEsiaFromBiometry);

/* feed */
export const sendEventFeedClick = createGASender(gaEvents.eventFeedClick);
export const sendEventFeedDecline = createGASender(gaEvents.eventFeedDecline);
export const sendEventFeedSuccess = createGASender(gaEvents.eventFeedSuccess);
export const sendEventFeedFinishClick = createGASender(gaEvents.eventFeedFinishClick);

/* credit cards landing */
export const sendEventShowCreditCardLanding = createGASender(gaEvents.eventShowCreditCardLanding);
export const sendEventOnSubmitLimitButton = createGASender(gaEvents.eventOnSubmitLimitButton);
export const sendEventOnSubmitCreditCardOffer = createGASender(gaEvents.eventOnSubmitCreditCardOffer);
